export default __webpack_public_path__ + "static/media/thermometer-three-quarters.9089dbc3.svg";